import { ROUTE_AUTH, ROUTE_AUTH_AUTHORIZE, ROUTE_AUTH_LOGIN, ROUTE_AUTH_SSO } from 'config/routes';
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { relativePath } from 'utils/navigation/relativePath';
import { AuthorizeView } from 'views/Auth/Authorize/Authorize.view';
import { SsoView } from 'views/Auth/Sso/Sso.view';
import { SignInView } from 'views/Auth/SignIn/SignIn.view';
import { NotFoundView } from 'views/Errors/NotFound.view';

export const AuthView: React.FC = () => {
  return (
    <Routes>
      <Route path={relativePath(ROUTE_AUTH_LOGIN, ROUTE_AUTH)} element={<SignInView />} />
      <Route path={relativePath(ROUTE_AUTH_AUTHORIZE, ROUTE_AUTH)} element={<AuthorizeView />} />
      <Route path={relativePath(ROUTE_AUTH_SSO, ROUTE_AUTH)} element={<SsoView />} />
      <Route path="*" element={<NotFoundView />} />
    </Routes>
  );
};
